/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetClientInfoQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetClientInfoQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    id: string;
    isAuthenticatedClient: boolean;
    capabilities: { __typename?: "ClientCapabilities"; canShop: boolean; canScheduleFix: boolean };
  } | null;
};

export const GetClientInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClientInfo" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isAuthenticatedClient" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "capabilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "canShop" } },
                      { kind: "Field", name: { kind: "Name", value: "canScheduleFix" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetClientInfoQuery__
 *
 * To run a query within a React component, call `useGetClientInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<GetClientInfoQuery, GetClientInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClientInfoQuery, GetClientInfoQueryVariables>(
    GetClientInfoDocument,
    options,
  );
}
export function useGetClientInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetClientInfoQuery, GetClientInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClientInfoQuery, GetClientInfoQueryVariables>(
    GetClientInfoDocument,
    options,
  );
}
// @ts-ignore
export function useGetClientInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientInfoQuery, GetClientInfoQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetClientInfoQuery, GetClientInfoQueryVariables>;
export function useGetClientInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClientInfoQuery, GetClientInfoQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetClientInfoQuery | undefined, GetClientInfoQueryVariables>;
export function useGetClientInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClientInfoQuery, GetClientInfoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetClientInfoQuery, GetClientInfoQueryVariables>(
    GetClientInfoDocument,
    options,
  );
}
export type GetClientInfoQueryHookResult = ReturnType<typeof useGetClientInfoQuery>;
export type GetClientInfoLazyQueryHookResult = ReturnType<typeof useGetClientInfoLazyQuery>;
export type GetClientInfoSuspenseQueryHookResult = ReturnType<typeof useGetClientInfoSuspenseQuery>;
export type GetClientInfoQueryResult = Apollo.QueryResult<
  GetClientInfoQuery,
  GetClientInfoQueryVariables
>;
